import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ValidationErrors } from "@angular/forms";
import { ErrorMessageComponent } from '../error-message/error-message.component';

type ErrorMessageKey = 'required' | 'number' | 'dateTime' | 'email' | 'maxlength' | 'minlength' | 'max' | 'min' | 'pattern' | 'noOverallImage' | 'dateOrUnknownRequired' | 'mgrs';

@Component({
  selector: 'app-input-wrapper',
  standalone: true,
  imports: [CommonModule, ErrorMessageComponent],
  templateUrl: './input-wrapper.component.html',
  styleUrls: ['./input-wrapper.component.scss']
})
export class InputWrapperComponent {
  @Input() label?: string;
  @Input() label2?: string;
  @Input() labelOnPress?: () => void;
  @Input() valueLabel?: string;
  @Input() required?: boolean;
  @Input() errorMessage?: ValidationErrors | null;
  @Input() touched?: boolean;
  @Input() alt?: boolean;
  @Input() onPress?: () => void;
  @Input() isStyled: boolean = true;
  @Input() leftIcon?: string;
  @Input() rightIcon?: string;
  @Input() disabled?: boolean;
  @Input() readonly?: boolean;
  @Input() dark?: boolean = false;

  @HostBinding('class.disabled') get isDisabled() {
    return this.disabled;
  }

  @HostBinding('class.alt') get isAlt() {
    return this.alt;
  }
  
  get translatedErrorMessage(): string {
    const errorMessages: Record<ErrorMessageKey, string> = {
      required: $localize`:@@input.errors.required:This field is required.`,
      number: $localize`:@@input.errors.number:Invalid number.`,
      dateTime: $localize`:@@input.errors.dateTime:Invalid date/time.`,
      email: $localize`:@@input.errors.email:Invalid email address.`,
      maxlength: $localize`:@@input.errors.maxlength:The value entered exceeds the max allowed length of {max}.`,
      minlength: $localize`:@@input.errors.minlength:This field does not meet the minimum length required of {min}.`,
      max: $localize`:@@input.errors.max:This field exceeds the maximum allowed value of {max}.`,
      min: $localize`:@@input.errors.min:This field does not meet the minimum required value of {min}.`,
      pattern: $localize`:@@input.errors.pattern:The value entered does not match the required pattern.`,
      noOverallImage: $localize`:@@input.errors.noOverallImage:At least one overall image is required.`,
      dateOrUnknownRequired: $localize`:@@input.errors.dateOrUnknownRequired:A date must be entered or the Unknown date box must be checked.`,
      mgrs: $localize`:@@input.errors.mgrs:Enter a valid MGRS reference with 4 to 10 digits, for example 48QXD1234567890.`
    };

    let errorOutput = [];

    if (this.touched && this.errorMessage) {
      let message = '';
      for (let error in this.errorMessage) {
        message = errorMessages[error as ErrorMessageKey]
        if (error === 'maxlength') {
          message = message.replace('{max}', this.errorMessage[error]['requiredLength'])
        } else if (error === 'minlength') {
          message = message.replace('{min}', this.errorMessage[error]['requiredLength'])
        } else if (error === 'max') {
          message = message.replace('{max}', this.errorMessage[error]['max'])
        } else if (error == 'min') {
          message = message.replace('{min}', this.errorMessage[error]['min'])
        } else if (error == 'pattern') {
          message = message.replace('{pattern}', this.errorMessage[error]['requiredPattern'])
        }
        errorOutput.push(message)
      }
    }

    return errorOutput.join('<br/>')
  }

  get wrapperClasses(): string[] {
    const classes: string[] = [];

    if (this.isStyled) {
      classes.push(this.onPress ? 'styled-touchable-wrapper' : 'styled-wrapper');
    } else {
      classes.push(this.onPress ? 'unstyled-touchable-wrapper' : 'unstyled-wrapper');
    }

    if (this.errorMessage && this.touched) {
      classes.push('error');
    }

    return classes;
  }
}